// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"icon-component_uk-open__WbZVX","grecaptcha-badge":"icon-component_grecaptcha-badge__FSsES","icon-svg":"icon-component_icon-svg__ZUvgY","icon-svg--outline":"icon-component_icon-svg--outline__Lrdlx","icon-svg--stroke-width":"icon-component_icon-svg--stroke-width__FRROc","icon-svg--filled":"icon-component_icon-svg--filled__ecvEa"};
    if(module.hot) {
      // 1793877030553
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  